import { User } from './user';

export class SystemAdmin extends User {
    IsDisabled: boolean;
}
